module.exports = __webpack_public_path__ + "static/img/blog_good_9.01377f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_9.png
// module id = ++Mp
// module chunks = 8